/**
 * Formats a file size in bytes to a human-readable string
 * @param bytes - The size in bytes
 * @returns Formatted string like "1.5 MB"
 */
export const formatFileSize = (bytes: number | undefined): string => {
  if (!bytes || bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

/**
 * Formats a date to a localized date string
 * @param date - The date to format
 * @returns Formatted date string or "N/A" if date is null
 */
export const formatDate = (date: Date | null): string => {
  if (!date) return "N/A";
  const newDate = new Date(date);
  return newDate.toLocaleDateString();
};
